import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=7d790559&scoped=true&"
import script from "./RatingStars.vue?vue&type=script&lang=js&"
export * from "./RatingStars.vue?vue&type=script&lang=js&"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=7d790559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d790559",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/builder/shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d790559')) {
      api.createRecord('7d790559', component.options)
    } else {
      api.reload('7d790559', component.options)
    }
    module.hot.accept("./RatingStars.vue?vue&type=template&id=7d790559&scoped=true&", function () {
      api.rerender('7d790559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RatingStars/RatingStars.vue"
export default component.exports